import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Gamepad2, Trophy, Gift, MessageSquare } from 'lucide-react';
import { ChatMentionBadge } from '../chat/ChatMentionBadge';

const destinations = [
  { id: 'originals', label: 'Originals', Icon: Gamepad2, to: '/originals' },
  { id: 'leaderboard', label: 'Leaderboard', Icon: Trophy, to: '/leaderboard' },
  { id: 'rewards', label: 'Rewards', Icon: Gift, to: '/vip-rewards' },
];

export const MobileBottomNavigation = ({ pathname, menuOpen, chatOpen, onMenu, onChat, onNavigate }) => {
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  useEffect(() => {
    const viewport = window.visualViewport;
    const update = () => {
      const editing = document.activeElement?.matches('input, textarea, [contenteditable=true]');
      const open = !!(editing && viewport && window.innerHeight - viewport.height > 120);
      setKeyboardOpen(open);
      document.documentElement.dataset.mobileKeyboard = String(open);
    };
    viewport?.addEventListener('resize', update);
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', update);
    return () => {
      viewport?.removeEventListener('resize', update);
      document.removeEventListener('focusin', update);
      document.removeEventListener('focusout', update);
      delete document.documentElement.dataset.mobileKeyboard;
    };
  }, []);
  return <nav className="mobile-bottom-navigation" data-testid="mobile-bottom-navigation" data-keyboard-open={keyboardOpen} aria-label="Mobile navigation">
    <button type="button" data-testid="mobile-nav-menu" aria-label={menuOpen ? 'Close menu' : 'Open menu'} aria-expanded={menuOpen} aria-controls="mobile-navigation-drawer" onClick={onMenu}><Menu size={21} aria-hidden="true" /><span>Menu</span></button>
    {destinations.map(({ id, label, Icon, to }) => {
      const active = !chatOpen && !menuOpen && (pathname === to || (id === 'originals' && pathname.startsWith('/games/')) || (id === 'rewards' && pathname === '/vip-rewards'));
      return <Link key={id} to={to} data-testid={`mobile-nav-${id}`} aria-current={active ? 'page' : undefined} onClick={onNavigate}><Icon size={21} aria-hidden="true" /><span>{label}</span></Link>;
    })}
    <button type="button" data-testid="mobile-nav-chat" aria-label={chatOpen ? 'Close community chat' : 'Open community chat'} aria-expanded={chatOpen} aria-controls="mobile-community-chat" onClick={onChat}><MessageSquare size={21} aria-hidden="true" /><span>Chat</span><ChatMentionBadge prefix="mobile" /></button>
  </nav>;
};